import { Button } from 'entities/Button'
import { useConfigStore } from '../../../shared/store/configSlice'

export const ResetMWLock = () => {
  const updateMenuConfig = useConfigStore().updateMenuConfig
  const menuConfig = useConfigStore().config?.menuConfig

  return (
    <Button
      isDisabled={!menuConfig?.QRMENU?.disabledByMobileWaiter}
      handleClick={() => updateMenuConfig({ disabledByMobileWaiter: false })}>
      Reset MW Lock
  </Button>
  )
}
